import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

type Props = {
    open: boolean;
    onClose: () => void;
};
type Lang = "english" | "hindi" | "marathi";

const messages: Record<Lang, string> = {
    english: "There is already an application with same Khasara Number & Plot Number in process. So your current application cannot be saved.",
    marathi: "सिस्टममध्ये समान खसरा क्रमांक व प्लॉट क्रमांकाचा अर्ज आधीच नोंदणीकृत आहे. त्यामुळे सदर अर्ज जतन करता येणार नाही.",
    hindi: "इस खसरा नंबर और प्लॉट नंबर का आवेदन सिस्टम में पहले से मौजूद है, इसलिए यह नया आवेदन सेव नहीं हो सकता।"
};

const cancelText: Record<Lang, string> = {
    english: "Cancel",
    marathi: "रद्द करा",
    hindi: "रद्द करें"
};

export function DuplicateApplicationPopup({ open, onClose }: Props) {
    const navigate = useNavigate();
    //const { lang } = useLanguage(); // Get current language (en/mr/hi)
    const lang = useLanguage();

    const currentLang: Lang =
        lang === "hindi" || lang === "marathi" ? lang : "english";

    if (!open) return null;

    const handleCancel = () => {
        onClose(); // close popup
        navigate("/user-applications"); // redirect to application table
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-[420px] text-center shadow-lg">
                <p className="text-base mb-6">{messages[currentLang]}</p>
                <button
                    onClick={handleCancel}
                    className="px-6 py-2 bg-primary text-white rounded-full font-semibold"
                >
                    {cancelText[currentLang]}
                </button>
            </div>
        </div>
    );
}